import { SVGProps } from 'react';

const PinScaleMediumAppearanceOutlinedCrossedTrue = (props: SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M8.49995 8.8841H5.27899L3.63948 10.5236L13.4766 20.3607L15.1161 18.7212V15.5M11.837 7.24458L13.4766 5.60507L12.6568 3.14579L14.2963 1.50628L22.4939 9.70385L20.8544 11.3434L18.3951 10.5236L16.7556 12.1631M1.99998 21.9995L7.73828 16.2612M1 1L23 23"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default PinScaleMediumAppearanceOutlinedCrossedTrue;
